import { createSlice } from "@reduxjs/toolkit";

const initialShipState = {
  listLoading: false,
  actionsLoading: false,
  entities: [],
  trimTo: undefined,
  backendTpmsRecords: [],
  missingTpmsRecords: []
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const tpmsRecordsSlice = createSlice({
  name: "tpmsRecords",
  initialState: initialShipState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    updateQueryParamsAndReset: (state, action) => {
      state.entities = [];
      state.trimTo = undefined;
      state.backendTpmsRecords = [];
      state.missingTpmsRecords = [];
    },
    tpmsRecordsFetched: (state, action) => {
      const { tpmsRecords } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.backendTpmsRecords = tpmsRecords;
      state.entities = tpmsRecords.map((x) => {
        const details = x.details;
        const tpmsPosA = details.find(({ position }) => position === "A");
        const tpmsPosB = details.find(({ position }) => position === "B");
        const tpmsPosC = details.find(({ position }) => position === "C");
        const tpmsPosD = details.find(({ position }) => position === "D");
        return {
          ...x,
          tpmsPosA: tpmsPosA?.tpms,
          tpmsPosB: tpmsPosB?.tpms,
          tpmsPosC: tpmsPosC?.tpms,
          tpmsPosD: tpmsPosD?.tpms,
        };
      });
    },
    // Update Sent column
    tpmsRecordUpdated: (state, action) => {
      const { Sent, Id } = action.payload.tpmsRecord;
      state.entities = state.entities.map((entity) => {
        if (entity.id === Id) {
          return { ...entity, sent:Sent };
        }
        return entity;
      });
      state.backendTpmsRecords = state.backendTpmsRecords.map((entity) => {
        if (entity.id === Id) {
          return { ...entity, sent:Sent };
        }
        return entity;
      });
    },
    tpmsRecordsSent: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    trimToUpdated: (state, action) => {
      const { trimTo } = action.payload;
      state.trimTo = trimTo;
    },
    tpmsMissingRecordsFetched: (state, action) => {
      const { missingTpmsRecords } = action.payload;
      state.missingTpmsRecords = missingTpmsRecords.map((x,index) => {
        return { id:index, trimSequence: x}
      });
      state.actionsLoading = false;
      state.error = null;
    }
  },
});
